// extracted by mini-css-extract-plugin
export default {"fallback":"fallback--QuEcE","loading":"loading--oOIjN"};